var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLanguage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E6F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73438 9.67188H20.1406V12.875H21.625V8.8125C21.625 8.4668 21.3457 8.1875 21 8.1875H7.875C7.5293 8.1875 7.25 8.4668 7.25 8.8125V23.1875C7.25 23.5332 7.5293 23.8125 7.875 23.8125H18.5V22.3281H8.73438V9.67188Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0918 11H12.9082C12.8418 11 12.7832 11.043 12.7598 11.1055L10.2773 18.293C10.2715 18.3086 10.2695 18.3262 10.2695 18.3438C10.2695 18.4297 10.3398 18.5 10.4258 18.5H11.502C11.5684 18.5 11.627 18.457 11.6504 18.3945L12.2891 16.5469H16.1211L14.2422 11.1055C14.2168 11.043 14.1582 11 14.0918 11ZM14.334 15.4531H12.6641L13.5 13.0352L14.334 15.4531ZM24.2812 16.3125H21.625V14.4961C21.625 14.4102 21.5547 14.3398 21.4688 14.3398H20.375C20.2891 14.3398 20.2188 14.4102 20.2188 14.4961V16.3125H17.5625C17.3027 16.3125 17.0938 16.5215 17.0938 16.7812V20.2188C17.0938 20.4785 17.3027 20.6875 17.5625 20.6875H20.2188V23.6562C20.2188 23.7422 20.2891 23.8125 20.375 23.8125H21.4688C21.5547 23.8125 21.625 23.7422 21.625 23.6562V20.6875H24.2812C24.541 20.6875 24.75 20.4785 24.75 20.2188V16.7812C24.75 16.5215 24.541 16.3125 24.2812 16.3125ZM20.2188 19.2812H18.5V17.7188H20.2188V19.2812ZM23.3438 19.2812H21.625V17.7188H23.3438V19.2812Z",
    fill: "#1890FF"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLanguage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Language.5fcecacd.svg";
export { ForwardRef as ReactComponent };